import { useState } from 'react';
import { heroHotTags, navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8 xl:px-14">
        <div className="flex h-14 items-center justify-between gap-4 md:h-16">
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
              15
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base font-bold tracking-tight text-foreground-950">
                15黑料网
              </span>
              <span className="mt-1 hidden font-label text-[10px] tracking-[0.28em] text-foreground-500 sm:block">
                档案 · 索引 · 信源
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-7 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="搜索档案"
              onClick={() => setSearchOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-search-line text-base" />
            </button>
            <a
              href="#subscribe"
              className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-notification-3-line text-base" />
              订阅速递
            </a>
            <button
              type="button"
              aria-label="展开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
            >
              <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'} />
            </button>
          </div>
        </div>
      </div>

      {searchOpen ? (
        <div className="w-full border-t border-background-200/70 bg-background-50">
          <div className="w-full px-4 py-3 md:px-8 xl:px-14">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <div className="relative flex-1">
                <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
                  <i className="ri-user-search-line text-base" />
                </span>
                <input
                  type="text"
                  name="archive-search"
                  placeholder="输入人物名或事件关键词，按人物索引快速定位"
                  className="w-full rounded-md border border-background-200 bg-background-100 py-2.5 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-300"
                />
              </div>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                查找档案
              </button>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <span className="font-label text-xs text-foreground-500">热搜：</span>
              {heroHotTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      ) : null}

      {menuOpen ? (
        <div className="w-full border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-2 md:px-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-200/60 py-3 font-label text-sm text-foreground-800 last:border-b-0"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-2 inline-flex cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-notification-3-line text-base" />
              订阅速递
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}